<template lang="pug">
	.box-notification
		template(v-if="notification")
			.notification.notification--error(v-if="notification.type=='error'")
				.notification__message {{$t('FORM.' + notification.message)}}
			.notification.notification--info(v-if="notification.type=='info'")
				.notification__message.icon-info {{$t('FORM.' + notification.message)}}
		.notification.notification--welcome.hide-desktop(v-if="showHello")
			.notification__message.notification__message--align-left {{$t('FORM.greetings')}} {{fullName}}!
			a.icon-close(@click="closeHello")
</template>
<script>
const SHOW_TIME = 5000;
import { mapGetters } from 'vuex';
export default {
	data: () => ({
		notification: null,
		showHello: false
	}),
	computed: {
		...mapGetters('auth', ['fullName'])
	},
	methods: {
		reset() {
			this.notification = null;
		},
		closeHello() {
			this.showHello = false;
		}
	},
	created() {
		window.ipEventBus.subscribe('show-error', (channel, errObj) => {
			this.notification = {
				type: 'error',
				message: errObj.message
			};
			if (!errObj.dontHide) {
				setTimeout(this.reset, SHOW_TIME);
			}
		});
		window.ipEventBus.subscribe('show-info', (channel, infoObj) => {
			this.notification = {
				type: 'info',
				message: infoObj.message
			};
			if (!infoObj.dontHide) {
				setTimeout(this.reset, SHOW_TIME);
			}
		});
		if (this.$cookies.get('hello')) {
			if (!this.$cookies.get('seenHello')) {
				this.$cookies.set('seenHello', true);
				this.showHello = true;
			}
		}
	}
};
</script>